"use client";

import { useActionState, useEffect, useState } from "react";
import Image from "next/image";
import { SendPhoneAction } from "@/app/actions";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import Alert from "@/app/_components/ui/Alert2";
import Button from "@/app/_components/ui/Button";
import { useAuthStore } from "@/stores/authStore";

export default function SendPhone() {
    const t = useTranslations("loginpage");
    const [state, formAction, pending] = useActionState(SendPhoneAction, undefined);
    const router = useRouter();
    const setOtp = useAuthStore((s) => s.setOtp);
    const [snackbar, setSnackbar] = useState<{
        open: boolean;
        message: string;
        severity: "success" | "error" | "info";
    }>({ open: false, message: "", severity: "info" });

    useEffect(() => {
        if (state?.success) {
            setSnackbar({
                open: true,
                message: "OTP Sent successfully!",
                severity: "success",
            });
            setTimeout(() => {
                setOtp(state.phone, state.data?.expiresIn ?? 0);
                router.push("/auth/verify-otp");
            }, 2000);
        } else if (state?.error) {
            setSnackbar({
                open: true,
                message: state.error,
                severity: "error",
            });
        }
    }, [state, router]);

    return (
        <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
            {/* Notification Alert */}
            {snackbar.open && (
                <div className="fixed top-4 right-4 z-50">
                    <Alert
                        type={snackbar.severity}
                        message={snackbar.message}
                        duration={3000}
                    />
                </div>
            )}

            <div className="relative w-full max-w-lg bg-secondary rounded-2xl shadow-sm p-2 lg:p-10 py-16">
                {/* Floating Logo Container */}
                <div className="absolute -top-20 left-1/2 -translate-x-1/2">
                    <div className="bg-white rounded-full p-1 border border-sky-100 shadow-sm">
                        <Image
                            src="/images/logo.png"
                            alt="Ministry of Peace Logo"
                            width={100}
                            height={100}
                            className="rounded-full"
                        />
                    </div>
                </div>

                <div className="text-center mb-10">
                    <h1 className=" font-black text-black tracking-tight">
                        {t("addphone")}
                    </h1>
                </div>

                <form action={formAction} className="space-y-8">
                    <div className="relative">
                        <input
                            id="phone"
                            name="phoneNumber"
                            type="text"
                            required
                            placeholder="+251 xx xxx xxxx"
                            className="w-full px-5 py-4 bg-white border border-sky-400 rounded-lg  text-gray-400 focus:outline-none focus:ring-2 focus:ring-sky-500 transition-all"
                        />
                    </div>

                    <Button
                        type="submit"
                        disabled={pending}
                        className="w-full py-4 bg-[#38BDF8] hover:bg-[#0EA5E9] text-white  font-medium rounded-lg shadow-sm transition-colors disabled:opacity-50"
                    >
                        {pending ? t("sening") : t("send")}
                    </Button>
                </form>
            </div>
        </div>
    );
}
